.root {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.labels {
  display: flex;
  justify-content: space-between;
  gap: var(--space-2);
}
